import { Link } from 'react-router-dom';
import type { PersonMergeItem } from '../../types';

// Every field the merge can preserve — the fill fields lose their slot whenever the kept
// record already had one, so they all surface here. Unknown keys fall back to the raw key.
const LABELS: Record<string, string> = {
  email: 'Email',
  phone: 'Phone',
  departedAt: 'Marked departed on',
  position: 'Title',
  crmFirstName: 'First name',
  crmLastName: 'Last name',
  crmEmail: 'CRM email',
  crmPhone: 'CRM phone',
  twitterHandle: 'Twitter',
  instagramHandle: 'Instagram',
  linkedInUrl: 'LinkedIn',
  temperature: 'Temperature',
  status: 'Next action',
  personalNote: 'Private note',
  nextFollowUpAt: 'Next follow-up',
  doNotCallAt: 'Do not call since',
  doNotCallBy: 'Do not call set by',
  lastVerifiedAt: 'Last verified',
};

export function MergedFromSection({ merges, personId }: { merges: PersonMergeItem[]; personId: string }) {
  const applied = merges.filter((m) => m.status === 'APPLIED' && m.survivorId === personId);
  if (applied.length === 0) return null;
  return (
    <div className="card p-4">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-2">From merged record{applied.length > 1 ? 's' : ''}</h3>
      <ul className="space-y-2 text-sm">
        {applied.map((m) => {
          const kept = Object.entries(m.preservedFields ?? {});
          const who = m.loser ? `${m.loser.crmFirstName || m.loser.firstName} ${m.loser.crmLastName || m.loser.lastName}` : 'a duplicate';
          return (
            <li key={m.id}>
              <div className="text-gray-700 dark:text-gray-300">Folded in {who}{m.appliedAt ? ` on ${new Date(m.appliedAt).toLocaleDateString()}` : ''}.</div>
              {kept.length > 0 && (
                <ul className="ml-4 list-disc text-gray-600 dark:text-gray-400">
                  {kept.map(([k, v]) => <li key={k}>{LABELS[k] ?? k}: {String(v)}</li>)}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
      <Link to="/coach-flags" className="mt-2 inline-block text-xs text-blast-600 hover:text-blast-700 dark:text-blast-400">
        See merge history
      </Link>
    </div>
  );
}
